import React from 'react';
import classnames from 'classnames';
import MenuList from '@wix/da-ds/pkg/Dropdown/MenuList';
import { useFakeAISuppressionItem, useFakeContentFilterItem, useThemeSwitcherItem, useSaleBannerItem, useBuyCoreItem, useHelpItem, useTermsItem, usePrivacyPolicyItem } from '../../../items';
import userMenuStyles from '../../UserMenuDesktop.scss';
import SiteHeaderStyles from '../../../../../SiteHeaderDesktop/SiteHeaderDesktop.scss';
const LoggedOutMenu = ({ className, disableThemeSwitcher })=>{
    const buyCoreItem = useBuyCoreItem();
    const saleBannerItem = useSaleBannerItem();
    const themeSwitcherItem = useThemeSwitcherItem();
    const contentFilterItem = useFakeContentFilterItem();
    const aiSuppressionItem = useFakeAISuppressionItem();
    const helpItem = useHelpItem();
    const termsItem = useTermsItem();
    const privacyPolicyItem = usePrivacyPolicyItem();
    return /*#__PURE__*/ React.createElement(MenuList, {
        id: "site-header-user-menu",
        className: classnames(className, userMenuStyles['user-menu'], SiteHeaderStyles['icon-submenu']),
        renderOnSSR: true,
        itemsFillContainerWidth: true,
        items: [
            {
                items: [
                    buyCoreItem,
                    saleBannerItem,
                    !disableThemeSwitcher && themeSwitcherItem,
                    // note: they kept the old toggle here even after 3 lvls of contentFilter
                    // were added because they thought it was better to send folks to sisu
                    contentFilterItem,
                    aiSuppressionItem
                ]
            },
            {
                items: [
                    helpItem,
                    termsItem,
                    privacyPolicyItem
                ]
            }
        ]
    });
};
LoggedOutMenu.displayName = 'LoggedOutMenu';
export default LoggedOutMenu;

//# sourceMappingURL=LoggedOutMenu.js.map